<template>
  <el-form
    :model="laboralTabForm"
    :rules="laboralTabFormRules"
    status-icon
    ref="laboralTabForm"
    @submit.native.prevent="next('laboralTabForm', laboralTabForm, contractId)"
  >
    <el-row :gutter="15" justify="center" type="flex">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="6">
            <el-form-item label="Tipo de contrato" prop="contractType">
              <el-select
                v-model="laboralTabForm.contractType"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
              >
                <el-option v-for="c in contractTypes" :key="c.id" :label="c.name" :value="c.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tipo de nómina" prop="paysheetType">
              <el-select
                v-model="laboralTabForm.paysheetType"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
              >
                <el-option
                  v-for="s in paysheetTypes"
                  :key="s.id"
                  :label="`${s.name} - ${s.description}`"
                  :value="s.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Salario" prop="currentSalary">
              <el-input
                size="small"
                v-model="laboralTabForm.currentSalary"
                type="number"
                step="0.01"
                min="0.01"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="10">
            <el-form-item label="Cargo" prop="department">
              <el-select
                v-model="laboralTabForm.department"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                clearable
                default-first-option
              >
                <el-option v-for="d in departments" :key="d.id" :label="d.name" :value="d.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Fecha de inicio de contrato" prop="contractStartDate">
              <el-input
                size="small"
                v-model="laboralTabForm.contractStartDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Fecha de fin de contrato" prop="contractEndDate">
              <el-input
                size="small"
                v-model="laboralTabForm.contractEndDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="$emit('cancel')" v-if="showCancel">Cancelar</el-button>
            <el-button size="small" @click="$emit('back')" v-else>Atrás</el-button>
            <el-button
              size="small"
              type="primary"
              native-type="submit"
            >{{nextName != null ? nextName : 'Continuar'}}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "NewcontractTabLaboral",
  props: ["values", "contractId", "nextName", "requireConfirm", "showCancel"],
  data() {
    const validateSalary = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido"));
      }

      if (value <= 0) {
        callback(new Error("El salario debe ser mayor a 0."));
        return false;
      }
      callback();
    };
    const validateDate = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback();
        return false;
      }

      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato de fecha incorrecto."));
        return false;
      }
      callback();
    };
    const validateDateR = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido"));
        return false;
      }

      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato de fecha incorrecto."));
        return false;
      }
      callback();
    };
    return {
      saving: false,
      contractTypes: [],
      paysheetTypes: [],
      departments: [],
      laboralTabForm: {
        contractType: null,
        department: null,
        contractStartDate: null,
        contractEndDate: null,
        paysheetType: null,
        currentSalary: null,
      },
      laboralTabFormRules: {
        contractType: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
        department: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
        contractStartDate: [
          {
            validator: validateDateR,
            trigger: "blur",
          },
        ],
        contractEndDate: [
          {
            validator: validateDate,
            trigger: "blur",
          },
        ],
        currentSalary: [
          {
            validator: validateSalary,
            trigger: "blur",
          },
        ],
        paysheetType: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeCreate() {
    axios
      .post("/", {
        query: `{
          contractTypes(where: { active: true }) { id name }
          departments(where: { active: true }) { id name }
          paysheetTypes(where: { active: true allEmployees: true }) { id name description }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          this.contractTypes = data.contractTypes;
          this.departments = data.departments;
          this.paysheetTypes = data.paysheetTypes;
        }
      });
  },
  methods: {
    next(formName, datos, contractId) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.saving = true;

        if (this.requireConfirm) {
          this.$confirm(
            "¿Estás seguro que deseas actualizar estos datos?",
            "Confirmación",
            {
              confirmButtonText: "Si, actualizar",
              cancelButtonText: "Cancelar",
              type: "warning",
            }
          )
            .then(() => {
              this.proceedSave(contractId, datos);
            })
            .catch((this.saving = false));
        } else {
          this.proceedSave(contractId, datos);
        }
      });
    },
    proceedSave(contractId, datos) {
      const contractStartDate = R.isNil(datos.contractStartDate)
        ? null
        : `"${datos.contractStartDate}"`;
      const contractEndDate = R.isNil(datos.contractEndDate)
        ? null
        : `"${datos.contractEndDate}"`;
      axios
        .post("/", {
          query: `mutation { 
              employeeUpdate(
                where: { id: "${contractId}" },
                data: {
                  contractType: ${datos.contractType},
                  department: ${datos.department},
                  contractStartDate: ${contractStartDate},
                  contractEndDate: ${contractEndDate},
                  currentSalary: ${datos.currentSalary},
                  paysheetType: ${datos.paysheetType},
                  contractComplete: 2
                }
              ) { id } 
            }`,
        })
        .then((res) => {
          const { data, error } = res.data;
          if (this.requireConfirm) {
            this.$notify({
              title: "Éxito",
              message: "Se ha actualizado la información correctamente.",
              type: "success",
            });
            this.$emit("save", true);
          } else {
            this.$message("Se ha guardado el avance.");
            this.$emit("next", {
              name: "laboral",
              data: datos,
            });
          }
        })
        .catch(console.log)
        .then((alw) => {
          this.saving = false;
        });
    },
  },
  mounted() {
    this.laboralTabForm = this.values;
    this.$refs["laboralTabForm"].resetFields();
  },
};
</script>
